import { Component } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './auth.service'; 
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ams';
  showMenu = false;

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }
  constructor(
    private router: Router,
    private authService: AuthService,
    private swUpdate: SwUpdate,
    private toastr: ToastrService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.authService.lastUrl = event.url;
      }
    });

    this.watchForAppUpdates();
  }

  private watchForAppUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        const toast = this.toastr.info('Click to load the latest AMS version.', 'Update available', {
          closeButton: true,
          disableTimeOut: true,
          tapToDismiss: true
        });

        toast.onTap.subscribe(() => {
          void this.swUpdate.activateUpdate().then(() => document.location.reload());
        });
      });

    this.swUpdate.unrecoverable.subscribe(() => {
      const toast = this.toastr.error('Click to reload AMS and recover cached files.', 'Reload required', {
        closeButton: true,
        disableTimeOut: true,
        tapToDismiss: true
      });

      toast.onTap.subscribe(() => document.location.reload());
    });
  }
}